import { Col, Form, Row, Spin, notification } from "antd";
import { useHistory } from "react-router-dom";

import { withProcedureWraper } from "../../../..";
import {
  Box,
  Icon,
  DatePicker,
  DepartmentSelect,
  BoxSection,
  ButtonList,
} from "../../../../../../components";

import { CoursesActionTable } from "../../components";
import { DateFormat } from "../../../../../../constants";

import { useMTPRequest, useMTPSteps, useUpdateMTP } from "../../hooks";
import { Routes } from "../../../../../../AppRoutes";
import { useQueryClient } from "@tanstack/react-query";

const MTPEdit = withProcedureWraper(() => {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const history = useHistory();

  const { mutate } = useUpdateMTP();
  const { data = {}, isLoading } = useMTPRequest();
  const { approve } = useMTPSteps();
  const { canEdit } = approve(data?.eApprovalProcess);

  const onFinish = (values: any) => {
    mutate(
      { id: data.id, body: values },
      {
        onSuccess() {
          queryClient.invalidateQueries({
            queryKey: ["MTP-requests"],
          });
          notification.success({
            message: "Thành công!",
            description: `Chỉnh sửa yêu cầu thành công.`,
          });
          history.push(`${Routes.monthlyTrainingPlanPage.path}/${data.id}`);
        },
        onError() {
          notification.error({
            message: "Thất bại",
            description: `Chỉnh sửa yêu cầu thất bại.`,
          });
        },
      }
    );
  };

  return (
    <Spin spinning={false}>
      <div className="pd15">
        <div className="PageHead flex-center">
          <div className="title" style={{ margin: 0 }}>
            <div className="btnBack" onClick={() => history.goBack()}>
              <Icon.ArrowLeft />
            </div>
            Chỉnh sửa kế hoạch đào tạo tháng
          </div>
        </div>
        {isLoading && <Spin style={{ width: "100%" }} />}
        {!isLoading && (
          <Form
            form={form}
            size="large"
            layout="vertical"
            onFinish={onFinish}
            initialValues={data}
          >
            <Box title="Thông tin">
              <Row gutter={[32, 0]}>
                <Col span={12}>
                  <Form.Item
                    required
                    label="Chọn tháng/năm"
                    name="eMonth"
                    rules={[
                      { required: true, message: "Vui lòng chọn tháng!" },
                    ]}
                  >
                    <DatePicker
                      format={DateFormat.MM_YYYY}
                      className="min-w-full"
                      picker="month"
                      placeholder="Chọn tháng..."
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    required
                    label="Cơ quan / Đơn vị"
                    name="eDepartment"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn Cơ quan/Đơn vị!",
                      },
                    ]}
                  >
                    <DepartmentSelect
                      disabled
                      className="min-w-full"
                      placeholder="Chọn cơ quan/đơn vị..."
                    />
                  </Form.Item>
                </Col>
              </Row>
              <BoxSection title="Nội dung chi tiết">
                <Form.Item noStyle name="eTrainingCourses">
                  <CoursesActionTable />
                </Form.Item>
              </BoxSection>
            </Box>
            <div className="flex-end">
              <ButtonList
                items={[
                  {
                    buttonType: "danger",
                    label: "Huỷ",
                    onClick: () => history.goBack(),
                    hidden: !canEdit,
                  },
                  {
                    buttonType: "warning",
                    label: "Xác nhận",
                    type: "submit",
                    hidden: !canEdit,
                  },
                ]}
              />
            </div>
          </Form>
        )}
      </div>
    </Spin>
  );
});

export default MTPEdit;
